import { useState } from 'react';

import { ButtonColor } from '@componentLibrary/buttons/Button';
import IconButton from '@componentLibrary/buttons/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { appendClasses } from '../../../helpers/ui';

import './NoticeBar.scss';

// TODO: Refactor this onto the component library Banner once Banner supports actions/dismissal.

type TNoticeBar = {
    message: string;
    className?: string;
    actionButton?: any;
    backgroundColor?: 'blue'; // default for now, can be extended if this is reused
    closeButtonColor?: ButtonColor;
};

export const NoticeBar = ({
    message,
    className,
    actionButton,
    backgroundColor = 'blue',
    closeButtonColor = 'white',
}: TNoticeBar) => {
    const classNamesAppended = appendClasses(['notice-bar', className, `color-${backgroundColor}`]);
    const [showNoticeBar, setShowNoticeBar] = useState(true);

    return (
        <>
            {showNoticeBar && (
                <div className={classNamesAppended}>
                    {message}
                    {actionButton}
                    <IconButton
                        className="close"
                        color={closeButtonColor}
                        onClick={() => setShowNoticeBar(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            )}
        </>
    );
};
